import Vue from 'vue';
import Vuex from 'vuex';
import order from './modules/order';
import modal from './modules/modal';

const modules = { order, modal };

const state = {
  notFound: false
};

const mutations = {};

for (const [name, module] of Object.entries(modules)) {
  modules[name] = { namespaced: true, ...module };
}

Vue.use(Vuex);
const store = new Vuex.Store({ state, mutations, modules });

export default store;
